<script setup lang="ts">
import {
  GoalAndPitchPositions,
  GoalPosition,
  PitchDistance,
  PitchPosition,
} from '@collector/mobile-feature-goal-and-pitch-positions'
import GroupTitle from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/GroupTitle.vue'

interface Props {
  name: string
  goalPositionDisabled?: boolean
  pitchPositionDisabled?: boolean
  isFulfilled?: boolean
}

defineProps<Props>()

// model
const goalPosition = defineModel<GoalPosition>('goalPosition', {
  default: null,
})
const pitchDistance = defineModel<PitchDistance>('pitchDistance', {
  default: null,
})
const pitchPosition = defineModel<PitchPosition>('pitchPosition', {
  default: null,
})
</script>

<template>
  <div class="space-y-4">
    <GroupTitle
      :name
      important
      :isFulfilled
    />

    <GoalAndPitchPositions
      v-model:goalPosition="goalPosition"
      v-model:pitchDistance="pitchDistance"
      v-model:pitchPosition="pitchPosition"
      :goalPositionDisabled
      :pitchPositionDisabled
    />
  </div>
</template>
